export enum SecureMessageStep {
  Init = 0,
  ValidateDob = 1,
  SetPassword = 2,
  ValidatePassword = 3,
  ViewMessage = 4,
  InvalidSession = 5
}

export interface RegisterParticipant {
  dateOfBirth: string;
}

export interface AuthenticateParticipant {
  password: string;
}

export interface ParticipantDobVerfication {
  dateOfBirth: string;
}

export interface ParticipantRegistration {
  dateOfBirth: string;
  password: string;
  passwordAgain: string;
}

export interface ParticipantAuthentication {
  password: string;
}
